export default "__VITE_ASSET__PjxW7u8Z__"